import React from 'react';
import { LuSave } from 'react-icons/lu';

// "Tenés … sin terminar" con Descartar / Seguir (20-oct-2026). Va arriba del formulario.
export default function AvisoBorrador({ texto, onSeguir, onDescartar }) {
    return (
        <div className="p-3 rounded-2xl bg-[var(--warning-bg)] border border-[#D48800]/30 flex items-center gap-3">
            <LuSave size={16} className="shrink-0 text-[var(--warning-tx)]" />
            <p className="flex-1 min-w-0 text-caption font-bold text-[var(--warning-tx)]">{texto}</p>
            <button type="button" onClick={onDescartar} className="shrink-0 px-2 py-1.5 text-label font-bold text-muted active:scale-95">Descartar</button>
            <button type="button" onClick={onSeguir} className="shrink-0 px-3 py-1.5 rounded-lg bg-[#C9341F] text-white text-label font-black active:scale-95">Seguir</button>
        </div>
    );
}
